import { render, staticRenderFns } from "./lightbox-vm18.vue?vue&type=template&id=5c307121&"
import script from "./lightbox-vm18.vue?vue&type=script&lang=js&"
export * from "./lightbox-vm18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c307121')) {
      api.createRecord('5c307121', component.options)
    } else {
      api.reload('5c307121', component.options)
    }
    module.hot.accept("./lightbox-vm18.vue?vue&type=template&id=5c307121&", function () {
      api.rerender('5c307121', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/lightbox-vm18.vue"
export default component.exports